export default __webpack_public_path__ + "images/8J.d43a749.png";